import { gql } from '@apollo/client'

const EDIT_POLICY_CLASS = gql`
  mutation EDIT_POLICY_CLASS(
    $policyClass: ID!
    $name: String!
    $maxLimit: Float
    $insuranceLimit: Float
    $insuranceUnlimited: Boolean
    $insurancePercentage: Float
    $approvalRequired: Boolean
    $disabled: Boolean
    $insurancePolicy: ID
  ) {
    editPolicyClass(
      policyClass: $policyClass
      name: $name
      maxLimit: $maxLimit
      insuranceLimit: $insuranceLimit
      insuranceUnlimited: $insuranceUnlimited
      insurancePercentage: $insurancePercentage
      approvalRequired: $approvalRequired
      disabled: $disabled
      insurancePolicy: $insurancePolicy
    ) {
      id
      name
      maxLimit
      insuranceLimit
      insurancePercentage
      insuranceUnlimited
      approvalRequired
      disabled
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export default EDIT_POLICY_CLASS
